<template>
  <div class="ColumnTitle flex items-end relative font-bold">
    <p>
      {{ title || $route.meta.title }}
    </p>
    <p v-if="total !== 0" class="total ml-4 text-lg font-bold">
      {{ total }}条数据
    </p>
  </div>
</template>

<script>
export default {
  name: "ColumnTitle",
  props: {
    title: {
      type: String,
      default: "",
    },
    total: {
      type: Number,
      default: 0,
    },
  },
};
</script>

<style lang="scss" scoped>
.ColumnTitle {
  $color: rgba(50, 128, 75, 1);
  font-size: 28px;
  color: $color;
  &::before {
    content: "";
    position: absolute;
    left: -27px;
    top: 50%;
    margin-top: -7px;
    border: 3px solid $color;
    width: 14px;
    height: 14px;
    border-radius: 50%;
  }
  .total {
    color: rgba(222, 155, 35, 1);
  }
}
</style>
